import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {map, takeUntil} from 'rxjs/operators';
import {InvestorTypeEnum} from '@EYN/components/goals';
import {planTypeToString} from "../../../../../projects/ey-nav-web-components/src/app/helpers/planTypeToString";
import {EynBaseComponent} from "@EYN/lib";

@Component({
    selector: 'eyn-next-steps',
    templateUrl: './next-steps.component.html',
    styleUrls: ['./next-steps.component.less']
})
export class NextStepsComponent extends EynBaseComponent implements OnInit {
    test: InvestorTypeEnum;

    planId: string;
    title: string;

    constructor(private router: ActivatedRoute) {
        super();
    }

    ngOnInit(): void {
        this.router.params
            .pipe(
                map(({planId}) => planId),
                takeUntil(this.unsubscribe$),
            )
            .subscribe(planId => {
                this.planId = planId;
                this.title = planTypeToString(Number(planId));
            });
    }
}
